import styled from "@emotion/styled";

export const Heading1 = styled.h1`
    font-size: 40px;
    font-weight: 700;
`;
export const Heading2 = styled.h2`
    font-size: 36px;
    font-weight: 700;
    text-transform: capitalize;
`;
export const Heading3 = styled.h3`
    font-size: 36px;
    font-weight: 700;
`;

export const Heading4 = styled.h4`
    font-size: 36px;
    font-weight: 700;
`;

export const Heading5 = styled.h5`
    font-size: 36px;
    font-weight: 700;
`;

export const Heading6 = styled.h6`
    font-size: 36px;
    font-weight: 700;
`;

export const Paragraph = styled.p`
    font-family: "Open Sans", sans-serif;
    font-size: 16px;
`;
